
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Договоры', path: '/contracts' },
            { id: 2, name: 'Заявки Логистов', path: '/contracts/bids' },
            { id: 3, name: 'Шаблоны', path: '/contracts/templates' },
            { id: 4, name: 'Настройки', path: '/contracts/settings' }
        ]

        return { tabs }
    },
})
